import Vue from 'vue'

let imagesAssetFolder = process.env.NODE_ENV === 'production'
  ? 'https://www.straitstimes.com/multimedia/graphics/assets/'
  : 'https://st-graphics-dev-assets.s3-ap-southeast-1.amazonaws.com/'

imagesAssetFolder += 'images/30-under-30-2020'

const BUCKET_URL = (process.env.NODE_ENV === 'production')
  ? 'https://www.straitstimes.com/multimedia/graphics/json/'
  : 'https://st-graphics-dev-json.s3.ap-southeast-1.amazonaws.com/'

const store = Vue.observable({
  projectName: '30-under-30-2020',
  sessionId: null,
  modelData: null,
  imagesAssetFolder,
  dataset: [],
  cabinet: [],
  section3: [],
  nonCabinet: [],
  member_name: [],
  BUCKET_URL
})

// Generate random string function
store.generateSessionId = function (length) {
  var randomID = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (var i = 0; i < length; i++) {
    randomID += characters.charAt(Math.floor(Math.random() * characters.length))
  }
  return randomID
}

// format topic
store.textFormat = function (text) {
  return text.replace(/:|,/gi, '').replace(/\s+/g, '-').toLowerCase()
}

export {store}
